import Message from './components/Message/Message.vue';

export default {
  name: 'Chat',
  props: ['id'],
  components: { Message },
  data() {
    return {
      currentCustomer: null,
      msg: null,
      file: '',
      panel: [0, 1],
      imgDialog: false,
      imgPreviewUrl: '',
      intervalId: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user || null;
    },
    loading() {
      return this.$store.state.loading || false;
    },
    tickets() {
      return this.$store.state.chat.tickets || [];
    },
    order() {
      return this.$store.state.chat.current_order || null;
    },
    isDeclined() {
      if (!this.order || !this.user) {
        return false;
      }
      const { ordersToExecutors } = this.order;
      const executorOrder = ordersToExecutors.find(
        el => el.executor_id === this.user.profile_id,
      );
      return executorOrder.status === 'declined';
    },
    files() {
      return this.currentCustomer && this.currentCustomer.messages
        ? this.currentCustomer.messages
          .filter(item => item.file_url)
          .map((item) => {
            const partsArray = item.file_url.split('.');
            const exec = partsArray[partsArray.length - 1];
            const title = item.file_name;
            const type = exec === 'pdf' ? 'doc' : 'img';
            return { type, url: item.file_url, title };
          })
        : [];
    },
  },
  methods: {
    /** Прокрутка вниз чата */
    scrollToBottom() {
      this.$refs.bottom.scrollIntoView({ behavior: 'smooth' });
    },
    changeStatus(item, status) {
      // this.loading = true;
      this.$store
        .dispatch('applications/changeStatus', { order_id: item.id, status })
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          this.$router.push('/applications');
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    /** добавление изображения
     * @param e - эвент */
    SetImage(e) {
      this.file = e && e.dataUrl ? e.dataUrl : '';
    },
    /** начало изменения размера картинки */
    async StartImageResize() {
      await this.$store.dispatch('SetLoading', true);
    },
    /** окончание изменения размера картинки */
    async EndImageResize() {
      await this.$store.dispatch('SetLoading', false);
    },
    OnSubmit() {
      const app = this;

      if (this.msg || this.file) {
        const payload = {
          profile_id: this.user.profile_id,
          model_id: this.currentCustomer.model_id,
          model_class: 'modules\\orders\\common\\models\\ExecutorOrder',
          message: this.msg,
          file: this.file,
        };
        this.$store
          .dispatch('chat/AddChatMessage', payload)
          .then(() => {
            this.msg = '';
            this.file = '';
          })
          .then(async () => {
            await this.$store
              .dispatch('chat/GetChatTickets', {
                profile_id: this.user.profile_id,
                order_id: this.$props.id,
              })
              .then((data) => {
                const currentId = app.currentCustomer.id;
                const currentTicket = data.tickets.find(
                  item => item.id === currentId,
                );

                if (currentTicket) {
                  app.$set(app.$data, 'currentCustomer', currentTicket);
                }
              });
          })
          .then(() => {
            this.scrollToBottom();
          })
          .catch((error) => {
            this.$store.dispatch('HandleError', error);
          });
      }
    },
    SetCurrentExecutor(exec) {
      const app = this;
      this.$set(this.$data, 'currentCustomer', exec);
      this.user
        && exec.model_id
        && this.$store
          .dispatch('chat/SetChatMessagesRead', {
            profile_id: this.user.profile_id,
            model_id: exec.model_id,
            model_class: 'modules\\orders\\common\\models\\ExecutorOrder',
          })
          .then(() => {
            app.scrollToBottom();
          });
    },
    ShowPreview(file) {
      const extArray = file.split('.');
      const type = extArray[extArray.length - 1] === 'pdf' ? 'doc' : 'img';
      if (type === 'doc') {
        window.open(file, '_blank');
      } else {
        this.imgPreviewUrl = file;
        this.imgDialog = true;
      }
    },
    ClosePreview() {
      this.imgPreviewUrl = '';
      this.imgDialog = false;
    },
    loadChatData() {
      const app = this;
      this.user
        && this.$props.id
        && this.$store
          .dispatch('chat/GetChatTickets', {
            profile_id: this.user.profile_id,
            order_id: this.$props.id,
          })
          .then((data) => {
            data
              && data.tickets
              && data.tickets.length
              && app.SetCurrentExecutor(data.tickets[0]);
          })
          .then(() => {
            app.scrollToBottom();
          });
    },
  },
  async mounted() {
    await this.$store.dispatch('SetTitle', 'Чат с заказчиком');
    await this.$store.dispatch('chat/GetOrderView', {
      profile_id: this.user.profile_id,
      order_id: this.$props.id,
    });
    this.loadChatData();
    this.intervalId = setInterval(() => {
      this.loadChatData();
    }, 60000);
  },
  async destroyed() {
    await this.$store.dispatch('chat/InitialStoreChat');
    clearInterval(this.intervalId);
  },
};
